import { UserLevelListContextProvider } from "../../context/UserLevelListContext";
import VIPIconContainer from "./components/VIPIconContainer";

const VIPIcon = ({ vipLevel = "VIP0", imageStyle = "" }) => {
  return (
    <UserLevelListContextProvider>
      <VIPIconContainer vipLevel={vipLevel} imageStyle={imageStyle} />
    </UserLevelListContextProvider>
  );
};

export default VIPIcon;
